import { toast } from "react-toastify";
import React, { useState, useEffect } from "react";
import Modal from "@/app/core/layouts/main/components/CustomModal";
import { AccountController } from "@/app/core/base/controllers/AccountController";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import { Panel, Tab, Tabs } from "@bumaga/tabs";
import { DateTranslate } from "@/app/core/util/DateTranslater";
import DeliveryHelper from "@/app/core/util/helpers/DeliveryHelper";
import { DeliveryController } from "@/app/core/base/controllers/DeliveryController";
import DeliveryModal from "../delivery/DeliveryModal";
import { UserStatusTranslate } from "@/app/core/util/helpers/UserHelper";
import { PhoneController } from "@/app/core/base/controllers/PhoneController";
import { PhoneHelper } from "@/app/core/util/helpers/PhoneHelper";

export default function UserModal({
    show,
    onHide,
    isLoading,
    infos
}) {
    const [data, setData] = useState({});
    const [deliveries, setDeliveries] = useState([]);
    const [phones, setPhones] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [deliveryId, setDeliveryId] = useState("");
    const date = new Date();
    const [startDate, setStartDate] = useState(
        getFirstDayOfMonth(date.getFullYear(), date.getMonth())
            .toISOString()
            .substring(0, 10)
    );
    const [endDate, setEndDate] = useState(
        getFirstDayOfMonth(date.getFullYear(), date.getMonth() + 1)
            .toISOString()
            .substring(0, 10)
    );

    function getFirstDayOfMonth(year, month) {
        return new Date(year, month, 1);
    }

    useEffect(() => {
        if (show) {
            setData(infos);
            loadDeliveries();
            loadPhones()
        }
    }, [infos, show]);

    async function loadDeliveries() {
        await DeliveryController.Filter(infos.id, startDate, endDate, res => setDeliveries(res));
    }

    async function loadPhones() {
        await PhoneController.GetByUser(infos.id, res => setPhones(res));
    }

    function saveUser() {
        updateUser();
    }

    async function updateUser() {
        if (parseInt(infos.role) != data.role) {
            await AccountController.Role(infos.id, data.role, res => { });
        }
        if (parseInt(infos.status) != data.status) {
            await AccountController.Status(infos.id, data.status, res => { });
        }
        await AccountController.Update(data, (res) => {
            toast.info(Translate(Message.Saved));
            onHide();
        });
    }

    function openDelivery(item) {
        setDeliveryId(item.id);
        setShowModal(true);
    }

    return (
        <Modal
            title="Usuário"
            show={show}
            isLoading={isLoading}
            onHide={onHide}
            onSave={saveUser}
            onSubmit={() => saveUser()}
        >
            <Tabs>
                <Tab>
                    <button className="btn btn-dual"><i className="si si-user" /> Conta</button>
                </Tab>
                <Tab>
                    <button className="btn btn-dual"><i className="fa fa-shipping-fast" /> Entregas</button>
                </Tab>
                <Panel>
                    <div className="row">
                        <div className="col-sm-6">
                            <label for="firstName">{Translate(Message.Name)}</label>
                            <br />
                            {data && data.firstName}
                        </div>
                        <div className="col-sm-6">
                            <label for="firstName">{Translate(Message.Surname)}</label>
                            <br />
                            {data && data.lastName}
                        </div>
                        <div className="col-sm-6">
                            <label for="email">Email</label>
                            <br />
                            {data && data.email}
                        </div>
                        <div className="col-sm-6">
                            <label for="phone">{Translate(Message.Phone)}</label>
                            <br />
                            <ul>
                                {phones && phones.map(item => <li>{PhoneHelper.PhoneMask(PhoneHelper.PhoneTranslate(item.number))}</li>)}
                            </ul>
                            {/* {data && data.phone } */}
                        </div>

                        <div className="col-sm-6">
                            <label for="status">Status</label>
                            <br />
                            {data && UserStatusTranslate(data.status)}
                        </div>
                    </div>
                </Panel>
                <Panel>
                    <div className="row">
                        <div className="form-group col-md-6">
                            <span>{Translate(Message.StartDate)}</span>
                            <input
                                type="date"
                                className="form-control form-control-alt"
                                value={startDate}
                                onChange={(evt) => setStartDate(evt.target.value)}
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <span>{Translate(Message.EndDate)}</span>
                            <input
                                type="date"
                                className="form-control form-control-alt"
                                value={endDate}
                                onChange={(evt) => setEndDate(evt.target.value)}
                            />
                        </div>
                        <table className="col-12 table table-hover">
                            <thead>
                                <tr>
                                    <th>{Translate(Message.DeliveryCode)}</th>
                                    <th>{Translate(Message.Origin)}</th>
                                    <th>{Translate(Message.Destination)}</th>
                                    <th>Status</th>
                                    <th>Pagamento</th>
                                    <th>{Translate(Message.RequestDate)}</th>
                                    {/* <th>{Translate(Message.Delivery.Delivery)}</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {deliveries && deliveries.map(item => (
                                    <tr>
                                        <td>{item.id}</td>
                                        <td>
                                            <span>
                                                <b>{item && item.origin && `${item.origin.number}, ${item.origin.street}, ${item.origin.neighborhood}`}</b>
                                                <br />
                                                <small>{item && item.origin && `${item.origin.city} - ${item.origin.state}`}</small>
                                            </span>
                                        </td>
                                        <td>
                                            <span>
                                                <b>{item && item.destination && `${item.destination.number}, ${item.destination.street}, ${item.destination.neighborhood}`}</b>
                                                <br />
                                                <small>{item && item.destination && `${item.destination.city} - ${item.destination.state}`}</small>
                                            </span>
                                        </td>
                                        <td>{DeliveryHelper().Status(item.status)}</td>
                                        <td>{item.paymentStatus}</td>
                                        <td>{DateTranslate(item.createdAt)}</td>
                                        <td>
                                            <button className="btn btn-dual" onClick={() => openDelivery(item)}><i className="fa fa-eye" /></button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Panel>
            </Tabs>
            <DeliveryModal
                show={showModal}
                deliveryId={deliveryId}
                onHide={() => setShowModal(false)} />
        </Modal>
    );
}
